<template>
  <b-modal
    :id="modalRefId"
    size="lg"
    ok-title="Chiudi"
    ok-variant="outline-secondary"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="calendar3"></b-icon>
        <span v-html="bdayModalTitle"></span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>

    <b-row style="width: -webkit-fill-available">
      <b-col>
        <registries
          :fields="fields"
          :repository="repository"
          :resource="resource"
          :ref="tableRef"
          :filterName="filterName"
          hasChecks
          noInnerWidth
          noActions
          noCustom
          noInputPaginator
          @selection-changed="onSelectionChanged"
          @birthdaysWithInsurancePolicies="birthdaysWithInsurancePolicies"
        >
        </registries>
        <!-- noPagination -->

        <b-row class="registry_legend">
          <div class="registry_item">
            <div class="registry_policy registry_yes_policy"></div>
            <p class="label">Clienti con polizze attive</p>
          </div>
          <div class="registry_item">
            <div class="registry_policy registry_no_policy"></div>
            <p class="label">Clienti senza polizze attive</p>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <modal-choose-email-models
      :hasEmail="hasEmailRecipients"
      :hasSms="hasSmsRecipients"
      title="Scegli modello e invia gli auguri di compleanno"
      sendLabel="Invia"
      :recipientsCount="selectedRecipients.length"
      @sendProcedure="sendProcedure"
    ></modal-choose-email-models>

    <template #modal-footer="{ cancel }">
      <b-btn
        variant="lisaweb"
        class="btn--smaller"
        size="sm"
        :disabled="!canSend"
        :title="sendTitle"
        @click="onOpenEmailModelsModal()"
        >Invia gli auguri di compleanno
      </b-btn>
      <b-btn @click="cancel()" size="sm" class="btn--transparent"
        >Chiudi
      </b-btn>
    </template>
  </b-modal>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import BaseIcon from "@/components/BaseIcon";
import ModalChooseEmailModels from "@/components/analysis/components/modalChooseEmailModels.vue";
import { RepositoryFactory as LisaComunicaRepositoryFactory } from "@/repositories/lisacomunica/RepositoryFactory";

// The analyses view and the contact columns LisaComunica resolves the
// recipients from (same contract as the "Prepara spedizioni" of Analisi).
const ANALYSES_VIEW = "registry_analyses_view";
const CONTACT_FIELDS = {
  email: ["MAIL", "SECONDARY_MAIL"],
  sms: ["CELL", "SECONDARY_CELL"],
};
const CHANNEL_LABELS = { email: "e-mail", sms: "cellulare" };

moment.locale("it");

export default {
  mixins: [StorageGetterMixin],
  data() {
    return {
      repository: "registry",
      resource: "registries",
      tableRef: "BirthdaysRegistryTableRef",
      modalRefId: "birthdayRegistryModal",
      filterName: "filterBirthdayRegistry",
      filter: this.initFilter(),
      selectedRecipients: [],
      fields: [
        {
          key: "check",
          label: "",
          sortable: false,
          thClass: "check",
          class: "check",
        },
        {
          key: "attributables.SURN",
          label: "Cognome",
        },
        {
          key: "attributables.NAME",
          label: "Nome",
        },
        // {
        //   key: "attributables.CNAM",
        //   label: "Ragione Sociale",
        // },
        {
          key: "attributables.NINO",
          label: "Codice Fiscale",
        },
        // {
        //   key: "attributables.CREG",
        //   label: "Partita IVA",
        // },
        {
          key: "email",
          label: "E-mail",
        },
        {
          key: "cellulare",
          label: "Cellulare",
        },
        {
          key: "telefono",
          label: "Telefono",
        },
      ],
    };
  },
  components: {
    Registries: () => import("@/components/tables/BirthdayRegistries"),
    BaseIcon,
    ModalChooseEmailModels,
  },
  computed: {
    bdayModalTitle() {
      return `Compleanni di oggi, ${moment().format("DD")}/${moment().format(
        "MM",
      )}`;
    },
    hasEmailRecipients() {
      return this.selectedRecipients.some((r) => r.email);
    },
    hasSmsRecipients() {
      return this.selectedRecipients.some((r) => r.sms);
    },
    // Senza destinatari raggiungibili la modale di scelta modelli non avrebbe
    // alcun canale utilizzabile: meglio dirlo qui che dopo la conferma.
    canSend() {
      return this.hasEmailRecipients || this.hasSmsRecipients;
    },
    sendTitle() {
      if (!this.selectedRecipients.length) {
        return "Seleziona almeno un destinatario";
      }
      return this.canSend
        ? ""
        : "Nessuno dei destinatari selezionati ha un recapito";
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId !== this.modalRefId) return;
      this.filter["byAttribute"]["DOB"] = null;
      this.selectedRecipients = [];
      this.$refs[this.tableRef]?.clearSelection();
    });
    /*
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      if (modalId === this.modalRefId) {
        let criteria = this.filter,
          name = this.filterName;
        this.filter["byAttribute"]["DOB"] = `%-${moment().format(
          "MM"
        )}-${moment().format("DD")}`;
        // store the filter
        this.saveFilterByName({ name, criteria });
        this.$refs[this.tableRef].fetch().then(() => {
          console.log("here v2");
        });
      }
    });
    */
  },
  methods: {
    moment,
    onSelectionChanged(recipients) {
      this.selectedRecipients = recipients;
    },
    onOpenEmailModelsModal() {
      this.$bvModal.show("modalScegliModelliEmail");
    },
    // Same LisaComunica contract as Analisi (see analysis/data/index.vue): the
    // recipients are restricted by registry id, so no saved extraction is
    // needed - just the id condition plus the contact columns of the channel.
    sendProcedure({ channel, template_id }) {
      if (!this.selectedRecipients.length) {
        this.$showSnackbar({
          preset: "error",
          text: "Seleziona almeno un destinatario prima di inviare.",
        });
        return;
      }
      // Recipients without a contact for the chosen channel are dropped here,
      // so what gets sent does not depend on how LisaComunica handles them.
      const label = CHANNEL_LABELS[channel];
      const eligible = this.selectedRecipients.filter((r) => r[channel]);
      const excluded = this.selectedRecipients.length - eligible.length;
      if (!eligible.length) {
        this.$showSnackbar({
          preset: "error",
          text: `Nessuno dei destinatari selezionati ha un recapito ${label}: invio non effettuato.`,
        });
        return;
      }
      const payload = {
        template_id,
        type: channel,
        // Shown as "Compleanni" in the client's Comunicazioni tab, not "Analisi".
        origin: "birthdays",
        conditions: [
          {
            view: ANALYSES_VIEW,
            field: "id",
            condition: "in",
            value: eligible.map((r) => r.id).join(","),
          },
        ],
        fields: [
          { view: ANALYSES_VIEW, field: "SURN" },
          { view: ANALYSES_VIEW, field: "NAME" },
          ...CONTACT_FIELDS[channel].map((field) => ({
            view: ANALYSES_VIEW,
            field,
          })),
        ],
      };
      const Repo = LisaComunicaRepositoryFactory.get(
        channel === "sms" ? "sms" : "email",
      );
      Repo.start(payload)
        .then(() => {
          const skipped = excluded
            ? ` ${excluded} ${
                excluded === 1 ? "destinatario" : "destinatari"
              } senza ${label} ${excluded === 1 ? "escluso" : "esclusi"}.`
            : "";
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Messaggio inviato.${skipped}`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        });
    },
    birthdaysWithInsurancePolicies() {
      console.log("emittato!");
      let criteria = this.filter,
        name = this.filterName;
      this.filter["byAttribute"]["DOB"] = `%-${moment().format(
        "MM",
      )}-${moment().format("DD")}`;
      // store the filter
      this.saveFilterByName({ name, criteria });
      this.$refs[this.tableRef].fetch().then(() => {
        console.log("here v2");
      });
    },
    initFilter() {
      let init = {
        byAttribute: {
          DOB: null,
        },
      };
      return init;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
    }),
  },
};
</script>
<style lang="scss" scoped>
.registry_legend {
  display: flex;
  gap: 25px;
  margin: 8px 0 0;
}

.registry_item {
  display: flex;
  gap: 5px;
}

.registry_policy {
  width: 15px;
  height: 15px;
  padding: 0;
  margin: 0;
  font-size: var(--font-size-sm);
}

.registry_yes_policy {
  background: rgba(19, 172, 19, 0.4);
}

.registry_no_policy {
  background: rgba(228, 33, 33, 0.3);
}

:deep(.table-responsive, .b-table-sticky-header) {
  max-height: 65vh !important; /* CSS keyword rolls back the value of a property in a cascade layer to the value of the property in a CSS rule matching the element in a previous cascade layer. */
}
</style>
